import { useEffect, useState } from "react";
import Logo from "../../images/brwlogo.avif";

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  const closeMobile = () => {
    setMobileOpen(false);
    setOpenSection(null);
  };

  const toggleSection = (name) =>
    setOpenSection((prev) => (prev === name ? null : name));

  // Lock body scroll + close on Escape while the drawer is open
  useEffect(() => {
    if (!mobileOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") closeMobile();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [mobileOpen]);

  return (
    <header id="masthead" className="header ttm-header-style-01">
      <div className="top_bar ttm-bgcolor-darkgrey clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-12">
              <div className="top_bar_contact_item">
                <span className="top_bar_icon">
                  <i className="fa fa-map-marker" />
                </span>
                <span className="top_bar_content">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.google.com/maps/dir//brw+contracting/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x88c2bbfa4c781b39:0xdafff6d9ce08c51b?sa=X&ved=2ahUKEwiO5uTz9fT8AhW-TTABHXPFABoQ9Rd6BAhIEAU"
                  >
                    2522 Hunt Rd, Land O' Lakes, FL 34638
                  </a>
                </span>
              </div>

              <div className="top_bar_contact_item">
                <span className="top_bar_icon">
                  <i className="fa fa-envelope-o" />
                </span>
                <span className="top_bar_content">
                  <a href="mailto:bidrequests@brwcontracting.org">
                    bidrequests@brwcontracting.org
                  </a>
                </span>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <div className="contact-info">
                <ul className="social-icons list-inline">
                  <li className="list-inline-item">
                    <a
                      target="_blank"
                      href="https://www.instagram.com/brwcontractinginc"
                      rel="noreferrer"
                      aria-label="instagram"
                      className="ttm-social-instagram"
                    >
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UCZK7Sk8HvNqLYKcdx4w2xrQ"
                      rel="noreferrer"
                      aria-label="youtube"
                      className="ttm-social-youtube"
                    >
                      <i className="fa fa-youtube" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/brwcontracting"
                      rel="noreferrer"
                      aria-label="facebook"
                      className="ttm-social-facebook"
                    >
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/brwcontracting/"
                      rel="noreferrer"
                      aria-label="linkedin"
                      className="ttm-social-linkedin"
                    >
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                </ul>

                <div className="top_bar_contact_item ttm-highlight-right">
                  <span className="top_bar_icon">
                    <i className="fa fa-phone" />
                  </span>
                  <span className="top_bar_content">
                    <a href="tel:18139965882">1 (813) 996-5882</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="site-header-menu" className="site-header-menu">
        <div className="site-header-menu-inner ttm-stickable-header">
          <div className="container">
            <div className="site-navigation navbar navbar-expand-lg p-0">
              <div className="site-branding">
                <a className="home-link" href="/" title="BRW Contracting">
                  <img loading="lazy" src={Logo} alt="BRW Contracting" />
                </a>
              </div>

              <button
                className={`mnav-toggle ms-auto${mobileOpen ? " is-active" : ""}`}
                type="button"
                aria-controls="mobile-nav"
                aria-expanded={mobileOpen}
                aria-label="Open navigation menu"
                onClick={() => setMobileOpen(true)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>

              <div
                id="site-navigation"
                className="collapse navbar-collapse justify-content-end"
              >
                <nav className="main-menu">
                  <ul className="menu nav navbar-nav">
                    <li className="nav-item">
                      <a className="nav-link" href="/">
                        Home
                      </a>
                    </li>

                    <li className="nav-item dropdown">
                      <a
                        href="/#"
                        className="nav-link dropdown-toggle"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>About</span>
                        <span className="nav-dropdown-arrow" aria-hidden="true">
                          ▾
                        </span>
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="/about">
                            About Us
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/team">
                            Our Team
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item dropdown">
                      <a
                        href="/#"
                        className="nav-link dropdown-toggle"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>Services</span>
                        <span className="nav-dropdown-arrow" aria-hidden="true">
                          ▾
                        </span>
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="/services">
                            Our Services
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/earthwork">
                            Earthwork
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/undergroundUtilities"
                          >
                            Underground Utilities
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/SegmentedRetainingWalls"
                          >
                            Segmented Block Retaining Walls
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/concrete">
                            Concrete
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/roadwayConstruction"
                          >
                            Roadway Construction
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/pavingStriping">
                            Paving & Striping
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li className="nav-item">
                      <a className="nav-link" href="/projects">
                        Projects
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/careers">
                        Careers
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/Join">
                        Join Us
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/contact">
                        Contact
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile slide-in navigation */}
      <div
        className={`mnav${mobileOpen ? " is-open" : ""}`}
        aria-hidden={!mobileOpen}
      >
        <button
          type="button"
          className="mnav-overlay"
          aria-label="Close navigation menu"
          tabIndex={mobileOpen ? 0 : -1}
          onClick={closeMobile}
        />

        <aside
          id="mobile-nav"
          className="mnav-panel"
          role="dialog"
          aria-modal="true"
          aria-label="Site menu"
        >
          <div className="mnav-head">
            <a href="/" className="mnav-logo" onClick={closeMobile}>
              <img src={Logo} alt="BRW Contracting" />
            </a>
            <button
              type="button"
              className="mnav-close"
              aria-label="Close navigation menu"
              onClick={closeMobile}
            >
              <span></span>
              <span></span>
            </button>
          </div>

          <nav className="mnav-links">
            <a href="/" className="mnav-link" onClick={closeMobile}>
              Home
            </a>

            <div className={`mnav-group${openSection === "about" ? " open" : ""}`}>
              <button
                type="button"
                className="mnav-acc"
                aria-expanded={openSection === "about"}
                onClick={() => toggleSection("about")}
              >
                <span>About</span>
                <span className="mnav-caret" aria-hidden="true">
                  ▾
                </span>
              </button>
              <div className="mnav-sub">
                <div className="mnav-sub-inner">
                  <a href="/about" onClick={closeMobile}>
                    About Us
                  </a>
                  <a href="/team" onClick={closeMobile}>
                    Our Team
                  </a>
                </div>
              </div>
            </div>

            <div
              className={`mnav-group${openSection === "services" ? " open" : ""}`}
            >
              <button
                type="button"
                className="mnav-acc"
                aria-expanded={openSection === "services"}
                onClick={() => toggleSection("services")}
              >
                <span>Services</span>
                <span className="mnav-caret" aria-hidden="true">
                  ▾
                </span>
              </button>
              <div className="mnav-sub">
                <div className="mnav-sub-inner">
                  <a href="/services" onClick={closeMobile}>
                    Our Services
                  </a>
                  <a href="/earthwork" onClick={closeMobile}>
                    Earthwork
                  </a>
                  <a href="/undergroundUtilities" onClick={closeMobile}>
                    Underground Utilities
                  </a>
                  <a href="/SegmentedRetainingWalls" onClick={closeMobile}>
                    Segmented Block Retaining Walls
                  </a>
                  <a href="/concrete" onClick={closeMobile}>
                    Concrete
                  </a>
                  <a href="/roadwayConstruction" onClick={closeMobile}>
                    Roadway Construction
                  </a>
                  <a href="/pavingStriping" onClick={closeMobile}>
                    Paving &amp; Striping
                  </a>
                </div>
              </div>
            </div>

            <a href="/projects" className="mnav-link" onClick={closeMobile}>
              Projects
            </a>
            <a href="/careers" className="mnav-link" onClick={closeMobile}>
              Careers
            </a>
            <a href="/Join" className="mnav-link" onClick={closeMobile}>
              Join Us
            </a>
            <a href="/contact" className="mnav-link" onClick={closeMobile}>
              Contact
            </a>
          </nav>

          <div className="mnav-foot">
            <a href="tel:18139965882" className="mnav-call">
              <i className="fa fa-phone" aria-hidden="true" />
              <span>1 (813) 996-5882</span>
            </a>
            <ul className="mnav-social">
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/brwcontractinginc"
                  aria-label="Instagram"
                >
                  <i className="fa fa-instagram" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/channel/UCZK7Sk8HvNqLYKcdx4w2xrQ"
                  aria-label="YouTube"
                >
                  <i className="fa fa-youtube" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/brwcontracting"
                  aria-label="Facebook"
                >
                  <i className="fa fa-facebook" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/brwcontracting/"
                  aria-label="LinkedIn"
                >
                  <i className="fa fa-linkedin" />
                </a>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </header>
  );
}

export default Header;
